export default __webpack_public_path__ + "static/media/zoom_in_enable.674f9237.svg";